import React, { FC } from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

interface Props extends BoxProps {}

export const SubComponentContainer: FC<Props> = props => {
  return <Box h="300px" position="relative" overflow="scroll" {...props} />;
};
